<template>
  <div id="m-mobile-new">
    <div class="new-top">
      <img src="../../../assets/mobile/6.png" width="100%"/>
      <div>
        <p>新闻中心</p>
        <span>News</span>
      </div>
    </div>
    <div class="mew-main">
      <van-cell is-link value="更多" @click="$router.push({path: '/mobileNewsMore' ,query: {type: 'G'}})">
        <template #title>
          <span class="custom-title">公司新闻</span>
        </template>
      </van-cell>
      <div class="main-body" v-for="(item,index) in TrendsDateG" @click="$router.push({path: '/mobileNewsDetail' , query: {id: item.fnewsId}})">
        <div style="height: 100%;width: 8rem;position: relative">
          <img :src="baseUrl + item.fimgUrl"/>
        </div>
        <div style="height: 100%;width: 12.2rem;position: relative">
          <p>{{item.ftitle}}</p>
          <span>{{item.freleaseDate}}</span>
        </div>
      </div>
    </div>
    <div class="mew-main">
      <van-cell is-link value="更多" @click="$router.push({path: '/mobileNewsMore' ,query: {type: 'H'}})">
        <template #title>
          <span class="custom-title">行业动态</span>
        </template>
      </van-cell>
      <div class="main-body" v-for="(item,index) in TrendsDateH" @click="$router.push({path: '/mobileNewsDetail' , query: {id: item.fnewsId}})">
        <div style="height: 100%;width: 8rem;position: relative">
          <img :src="baseUrl + item.fimgUrl"/>
        </div>
        <div style="height: 100%;width: 12.2rem;position: relative">
          <p>{{item.ftitle}}</p>
          <span>{{item.freleaseDate}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from "../../../../static/js/commonAxios";

  export default {
    name: "mobileNews",
    data(){
      return{
        TrendsDateG: [],
        TrendsDateH: [],
        baseUrl: ''
      }
    },
    mounted(){
      this.baseUrl = process.env.API_ROOT;
      this.getPageDateG()
      this.getPageDateH()
    },
    methods: {
      getPageDateG(){
        axios.get(`/api/newsPage?page=1&limit=3&fnewsType=G`).then((res) => {
          if(res.data.success){
            this.TrendsDateG = res.data.items
          }else{
            this.$message.error(res.data.msg)
          }
        })
      },
      getPageDateH(){
        axios.get(`/api/newsPage?page=1&limit=3&fnewsType=H`).then((res) => {
          if(res.data.success){
            this.TrendsDateH = res.data.items
          }else{
            this.$message.error(res.data.msg)
          }
        })
      },
    },
  }
</script>

<style>
  #m-mobile-new {
    background-color: #fff;
    margin-top: 3.25rem;
  }
  #m-mobile-new .new-top {
    position: relative;
  }
  #m-mobile-new .new-top div {
    position: absolute;
    left: 2.22rem;
    top: 50%;
    transform: translateY(-50%);
  }
  #m-mobile-new .new-top div p {
    font-size: 1.31rem;
    font-weight: 500;
    color: #FFFFFF;
  }
  #m-mobile-new .new-top div span {
    font-size: 0.75rem;
    font-weight: 400;
    color: #FFFFFF;
    opacity: 0.6;
  }
  #m-mobile-new .mew-main {
  padding: 1.5rem;
}
  #m-mobile-new .mew-main .main-body {
    height: 6.2rem;
    display: flex;
    justify-content: space-between;
    margin: .2rem 0;
    overflow: hidden;
    box-sizing: border-box;
    padding: 0.53rem 0;
  }
#m-mobile-new .mew-main .main-body div img{
  position: absolute;
  width: 7.2rem;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
  #m-mobile-new .mew-main .main-body div p {
    position: absolute;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    font-size: 0.94rem;
    font-weight: 400;
    color: #333333;
    top: .5rem;
  }
  #m-mobile-new .mew-main .main-body div span {
    position: absolute;
    font-size: 0.75rem;
    font-weight: 400;
    color: #BABABA;
    bottom: .5rem;
  }
  #m-mobile-new .van-cell {
    padding: 1rem 0;
  }
  #m-mobile-new .custom-title {
    font-size: 1.13rem;
    font-weight: 500;
    color: #000000;
  }
</style>



// WEBPACK FOOTER //
// src/components/Mobile/mobileNews/mobileNews.vue